'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _forgotPassword = require('./forgot-password.html');

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _forgotPassword2.default,
  bindings: {
    userName: '<'
  },
  controller: function () {
    function ForgotPasswordComponent($state, AuthService, ToastService) {
      'ngInject';

      _classCallCheck(this, ForgotPasswordComponent);

      Object.assign(this, { $state: $state, AuthService: AuthService, ToastService: ToastService });
    }

    _createClass(ForgotPasswordComponent, [{
      key: '$onInit',
      value: function $onInit() {}
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        var _this = this;

        try {
          this.AuthService.forgotPassword(this.userName).then(function () {
            _this.$state.go('resetPasswordFromPin', { userName: _this.userName });
          });
        } catch (e) {
          this.ToastService.showError();
        }
      }
    }]);

    return ForgotPasswordComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/auth/forgot-password/forgot-password.component.js